/**
 * The competition catalog, ported from `mobileJarvisServer`
 * `src/constants/competitions.ts`. Both copies are hardcoded until the list
 * moves to Firestore; until then this file and that one must agree.
 *
 * SYNC: mobileJarvisServer/src/constants/competitions.ts
 *
 * Jarvis stores only opaque ids — `student.competitionSubmissions` keys and
 * the legacy `artwork.competitionIds` — so a display name has no other
 * source. Ids are permanent (records reference them) and `slots` is
 * append-only: the array INDEX is the `slotIndex` written into
 * `competitionSubmissions`, so reordering silently relabels every existing
 * entry.
 */

export interface Competition {
  id: string
  name: string
  isActive: boolean
  /** Ordered submission boxes; index = `slotIndex`. Absent = not slot-based. */
  slots?: readonly string[]
}

export const COMPETITIONS: readonly Competition[] = [
  {
    id: "FamilyFA26",
    name: "Fall 2026 Family Creative Challenge",
    isActive: true,
    slots: ["Child's cow", "Parent's cow"],
  },
]

const COMPETITIONS_BY_ID: Record<string, Competition> = Object.fromEntries(
  COMPETITIONS.map((competition) => [competition.id, competition])
)

export const getCompetition = (id: string): Competition | undefined =>
  COMPETITIONS_BY_ID[id]

/** An id the catalog does not know still has to render, so it labels itself. */
export const getCompetitionName = (id: string): string =>
  COMPETITIONS_BY_ID[id]?.name ?? id

/**
 * The box's name ("Parent's cow"), or a 1-based fallback for a competition
 * the catalog does not name — which is the whole point of the fallback: a
 * judge can still tell two boxes apart.
 */
export const getCompetitionSlotLabel = (
  id: string,
  slotIndex: number
): string =>
  COMPETITIONS_BY_ID[id]?.slots?.[slotIndex] ?? `Slot ${slotIndex + 1}`
